/**
 * press-modal.js — 中文报道「英文翻译摘录」弹窗。
 *
 * 触发:点击带 [data-press-modal] 的卡片(中文公众号报道)→ 阻止跳转,弹窗展示
 *      卡片的英文摘录(data-excerpt)+ 媒体名/日期 + 原文链接(卡片 href)。
 * 无 JS 时卡片回退为普通外链(渐进增强)。
 * 关闭:右上 ×、点遮罩、Esc。视觉由 components.css(.press-modal*)。
 */
(function () {
  function init() {
    const dialog = document.querySelector('[data-press-modal-dialog]');
    if (!dialog || dialog.dataset.ready === '1') return;
    dialog.dataset.ready = '1';

    const elCat = dialog.querySelector('[data-modal-cat]');
    const elTitle = dialog.querySelector('[data-modal-title]');
    const elMeta = dialog.querySelector('[data-modal-meta]');
    const elExcerpt = dialog.querySelector('[data-modal-excerpt]');
    const elOriginal = dialog.querySelector('[data-modal-original]');
    let lastFocus = null;

    function open(card) {
      const q = (sel) => card.querySelector(sel);
      elCat.textContent = q('.press-card__cat') ? q('.press-card__cat').textContent : '';
      elTitle.textContent = q('.press-card__title') ? q('.press-card__title').textContent : '';
      const outletEl = q('.press-card__outlet');
      // 取媒体名纯文本(排除内嵌的 CN/JP 语言标签)
      const outlet = outletEl ? (outletEl.firstChild ? outletEl.firstChild.textContent : outletEl.textContent).trim() : '';
      const date = q('.press-card__date') ? q('.press-card__date').textContent : '';
      elMeta.textContent = [outlet, date].filter(Boolean).join('  ·  ');
      elExcerpt.textContent = card.getAttribute('data-excerpt') || '';
      elOriginal.href = card.getAttribute('href') || '#';
      lastFocus = card;
      dialog.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const closeBtn = dialog.querySelector('.press-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      dialog.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    document.querySelectorAll('[data-press-modal]').forEach((card) => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        open(card);
      });
    });

    dialog.querySelectorAll('[data-press-modal-close]').forEach((el) => {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !dialog.hidden) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
